import Row from "@amzn/meridian/row"
import React, { useContext, useEffect } from "react"
import { useDeviceLayout } from "../../commons/context/DeviceLayoutContext"
import Box from "@amzn/meridian/box"
import { ViewDataContext } from "../../commons/context/view/ViewDataContext"
import { DwellFilterContext } from "../../commons/context/DwellFilterContext"
import { DWELL_PACKAGE_STATUS, getPackageDrilDownRequestFilter, getPackageOverallMetrics, getRequestFilterForDwellingView, PACKAGE_STATUSES_DEPART, PACKAGE_STATUSES_HELD, PACKAGE_STATUSES_INDUCTED, PACKAGE_STATUSES_JACKPOT_BUFFERED, PACKAGE_STATUSES_PENDING_INDUCT, PACKAGE_STATUSES_PICK, PACKAGE_STATUSES_PROBLEM_SOLVE, PACKAGE_STATUSES_STAGE, PACKAGE_STATUSES_STOW_BUFFERED, PACKAGE_STATUSES_STOWED } from "../../util/CommonUtils"
import ActionableMetricView from "./ActionableMetricView"
import { FormattedMessage } from "react-intl"
import { DWELL_FILTER_ACTIONS, FEATURES, ONE_HOUR } from "../../commons/constants/CommonConstants"
import { FeatureConfigContext } from "../../commons/context/FeatureConfigContext"
import { chainWalk } from "../../commons/CommonUtils"


const DwellOverallStatus = (props) => {

    const {spacingInset_shorthand4} = useDeviceLayout();
    const {viewModel, dispatch} = useContext(ViewDataContext);
    const {filterDispatcher} = useContext(DwellFilterContext);
    const {configViewModel} = useContext(FeatureConfigContext);

    const selectedTabForPackages = props.selectedTabForPackages;

    const isOneHourView = () => {
        return selectedTabForPackages === ONE_HOUR;
    }
    
    let packageDwellMetrics = getPackageOverallMetrics(viewModel.metricResult);
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let stationCode = params.get('stationCode');
    const addShipOptionForDwellDetail = chainWalk(() => configViewModel.featureStatus[FEATURES.IS_SHIP_OPTION_FILTER_FOR_DRILL_DOWN_API_ENABLED], false);
    const addShipOptionForMetricsApiEnabled = chainWalk(() => configViewModel.featureStatus[FEATURES.IS_SHIP_OPTION_FILTER_FOR_METRICS_API_ENABLED], false);
    let selectedFilterValuesForDwellingView = getRequestFilterForDwellingView(selectedTabForPackages, addShipOptionForMetricsApiEnabled);
    
    useEffect(() => {
        dispatch({
            type: "LOAD_VIEW",
            data: {
                filters: selectedFilterValuesForDwellingView , stationCode, view : "DWELLING_VIEW" ,dispatcher: dispatch, leg:"FORWARD", isCPTFilter: false
            }
        })
    }, [selectedTabForPackages])
    return (
        <React.Fragment>
            <Row wrap="down" spacingInset={spacingInset_shorthand4} spacing="medium" width="100%"
                    alignmentVertical="stretch">

                    <Box type="outline" spacingInset="medium">
                        <b><FormattedMessage id="dwell.TotalPackageHeading" defaultMessage="Total"/></b>
                            <Row width="100%" spacing="large" alignmentVertical="bottom">
                                <ActionableMetricView
                                    dwellStatus={{
                                        title: "dwell.totalPackages",
                                        message: "Packages",
                                        value: packageDwellMetrics.totalPackages
                                    }}/>
                            </Row>
                        
                    </Box>

                    <Box type="outline" spacingInset="medium">
                        <b><FormattedMessage id="dwell.problemSolveHeading" defaultMessage="PS"/></b>
                            <Row width="100%" spacing="large" alignmentVertical="bottom">
                                <ActionableMetricView
                                    onMetricCountClick={() => { 
                                        dispatch({ type: 'LOAD_VIEW', data:{filters: getPackageDrilDownRequestFilter(viewModel.metricResult, selectedTabForPackages, PACKAGE_STATUSES_PROBLEM_SOLVE, viewModel.stationTimeZone, addShipOptionForDwellDetail), 
                stationCode, view : "PACKAGE_DRILLDOWN", prevView : viewModel.prevView, leg : "FORWARD", dispatcher: dispatch, isCPTFilter: false, 
                filterDispatcher: filterDispatcher
            }})
            filterDispatcher({type: DWELL_FILTER_ACTIONS.SELECT_TILE, selectedTile: [DWELL_PACKAGE_STATUS.EXCEPTIONS_PS]});
        }}
                                    dwellStatus={{
                                        title: "dwell.exceptionProblemSolve",
                                        message: "PS",
                                        value: packageDwellMetrics.exceptionProblemSolvePackages
                                    }}/>
                                
                            </Row>
                    </Box>

                    <Box type="outline" spacingInset="medium">
                        <b><FormattedMessage id="dwell.heldHeading" defaultMessage="Held"/></b>
                            <Row width="100%" spacing="large" alignmentVertical="bottom">
                                <ActionableMetricView
                                    onMetricCountClick={() => {
                                        dispatch({ type: 'LOAD_VIEW', data:{filters: getPackageDrilDownRequestFilter(viewModel.metricResult, selectedTabForPackages, PACKAGE_STATUSES_HELD, viewModel.stationTimeZone, addShipOptionForDwellDetail), 
                stationCode, view : "PACKAGE_DRILLDOWN", prevView : viewModel.prevView, leg : "FORWARD", dispatcher: dispatch, isCPTFilter: false, 
                filterDispatcher: filterDispatcher
            }})
            filterDispatcher({type: DWELL_FILTER_ACTIONS.SELECT_TILE, selectedTile: [DWELL_PACKAGE_STATUS.HELD]});
                                    }}
                                    dwellStatus={{
                                        title: "dwell.held",
                                        message: "Held",
                                        value: packageDwellMetrics.heldPackages
                                    }}/>
                                
                            </Row>
                    </Box>

                    <Box type="outline" spacingInset="medium">
                        <b><FormattedMessage id="dwell.InductHeading" defaultMessage="Induct"/></b>
                            <Row width="100%" spacing="large" alignmentVertical="bottom">
                                <ActionableMetricView
                                    onMetricCountClick={() => {
                                        dispatch({ type: 'LOAD_VIEW', data:{filters: getPackageDrilDownRequestFilter(viewModel.metricResult, selectedTabForPackages, PACKAGE_STATUSES_PENDING_INDUCT, viewModel.stationTimeZone, addShipOptionForDwellDetail), 
                stationCode, view : "PACKAGE_DRILLDOWN", prevView : viewModel.prevView, leg : "FORWARD", dispatcher: dispatch, isCPTFilter: false, 
                filterDispatcher: filterDispatcher
            }})
            filterDispatcher({type: DWELL_FILTER_ACTIONS.SELECT_TILE, selectedTile: [DWELL_PACKAGE_STATUS.INDUCT_PENDING]});
                                    }}
                                    dwellStatus={{
                                        title: "dwell.pendingInduct",
                                        message: "Pending",
                                        value: packageDwellMetrics.inductPendingPackages
                                    }}/>
                                <ActionableMetricView
                                    onMetricCountClick={() => {
                                        dispatch({ type: 'LOAD_VIEW', data:{filters: getPackageDrilDownRequestFilter(viewModel.metricResult, selectedTabForPackages, PACKAGE_STATUSES_INDUCTED, viewModel.stationTimeZone, addShipOptionForDwellDetail), 
                stationCode, view : "PACKAGE_DRILLDOWN", prevView : viewModel.prevView, leg : "FORWARD", dispatcher: dispatch, isCPTFilter: false, 
                filterDispatcher: filterDispatcher
            }})
            filterDispatcher({type: DWELL_FILTER_ACTIONS.SELECT_TILE, selectedTile: [DWELL_PACKAGE_STATUS.INDUCTED]});
                                    }}
                                    dwellStatus={{
                                        title: "dwell.inducted",
                                        message: "Inducted",
                                        value: packageDwellMetrics.inductedPackages
                                    }}/>
                            </Row>
                        
                    </Box>

                    <Box type="outline" spacingInset="medium">
                        <b><FormattedMessage id="dwell.stowedHeading" defaultMessage="Stow"/></b>
                            <Row width="100%" spacing="large" alignmentVertical="bottom">
                                <ActionableMetricView
                                    onMetricCountClick={() => {
                                        dispatch({ type: 'LOAD_VIEW', data:{filters: getPackageDrilDownRequestFilter(viewModel.metricResult, selectedTabForPackages, PACKAGE_STATUSES_STOWED, viewModel.stationTimeZone, addShipOptionForDwellDetail), 
                stationCode, view : "PACKAGE_DRILLDOWN", prevView : viewModel.prevView, leg : "FORWARD", dispatcher: dispatch, isCPTFilter: false, 
                filterDispatcher: filterDispatcher
            }})
            filterDispatcher({type: DWELL_FILTER_ACTIONS.SELECT_TILE, selectedTile: [DWELL_PACKAGE_STATUS.STOWED]});
                                    }}
                                    dwellStatus={{
                                        title: "dwell.stowed",
                                        message: "Stowed",
                                        value: packageDwellMetrics.stowedPackages
                                    }}/>
                                <ActionableMetricView
                                    onMetricCountClick={() => {
                                        dispatch({ type: 'LOAD_VIEW', data:{filters: getPackageDrilDownRequestFilter(viewModel.metricResult, selectedTabForPackages, PACKAGE_STATUSES_STOW_BUFFERED, viewModel.stationTimeZone, addShipOptionForDwellDetail), 
                stationCode, view : "PACKAGE_DRILLDOWN", prevView : viewModel.prevView, leg : "FORWARD", dispatcher: dispatch, isCPTFilter: false, 
                filterDispatcher: filterDispatcher
            }})
            filterDispatcher({type: DWELL_FILTER_ACTIONS.SELECT_TILE, selectedTile: [DWELL_PACKAGE_STATUS.STOW_BUFFERED]});
                                    }}
                                    dwellStatus={{
                                        title: "dwell.stowed.buffered",
                                        message: "Buffered",
                                        value: packageDwellMetrics.stowBufferedPackages
                                    }}/>
                            </Row>
                    </Box>

                    <Box type="outline" spacingInset="medium">
                        <b><FormattedMessage id="dwell.jackpotBufferedHeading" defaultMessage="Jackpot"/></b>
                            <Row width="100%" spacing="large" alignmentVertical="bottom">
                                <ActionableMetricView
                                    onMetricCountClick={() => {
                                        dispatch({ type: 'LOAD_VIEW', data:{filters: getPackageDrilDownRequestFilter(viewModel.metricResult, selectedTabForPackages, PACKAGE_STATUSES_JACKPOT_BUFFERED, viewModel.stationTimeZone, addShipOptionForDwellDetail), 
                stationCode, view : "PACKAGE_DRILLDOWN", prevView : viewModel.prevView, leg : "FORWARD", dispatcher: dispatch, isCPTFilter: false, 
                filterDispatcher: filterDispatcher
            }})
            filterDispatcher({type: DWELL_FILTER_ACTIONS.SELECT_TILE, selectedTile: [DWELL_PACKAGE_STATUS.JACKPOT_BUFFERED]});
                                    }}
                                    dwellStatus={{
                                        title: "dwell.jackpot.buffered",
                                        message: "Buffered",
                                        value: packageDwellMetrics.jackpotBufferedPackages
                                    }}/>
                            </Row>
                    </Box>
                    {isOneHourView() ? null :
                        <React.Fragment>
                            <Box type="outline" spacingInset="medium">
                                <b><FormattedMessage id="dwell.stowedHeading" defaultMessage="Pick"/></b>
                                    <Row width="100%" spacing="large" alignmentVertical="bottom">
                                        <ActionableMetricView
                                            onMetricCountClick={() => {
                                                dispatch({ type: 'LOAD_VIEW', data:{filters: getPackageDrilDownRequestFilter(viewModel.metricResult, selectedTabForPackages, PACKAGE_STATUSES_PICK, viewModel.stationTimeZone, addShipOptionForDwellDetail), 
                stationCode, view : "PACKAGE_DRILLDOWN", prevView : viewModel.prevView, leg : "FORWARD", dispatcher: dispatch, isCPTFilter: false, 
                filterDispatcher: filterDispatcher
            }})
            filterDispatcher({type: DWELL_FILTER_ACTIONS.SELECT_TILE, selectedTile: [DWELL_PACKAGE_STATUS.PICKED]});
                                            }}
                                            dwellStatus={{
                                                title: "dwell.pick",
                                                message: "Picked",
                                                value: packageDwellMetrics.pickedPackages
                                            }}/>
                                    </Row>
                            </Box>
                            <Box type="outline" spacingInset="medium">
                                <b><FormattedMessage id="dwell.stowedHeading" defaultMessage="Stage"/></b>
                                    <Row width="100%" spacing="large" alignmentVertical="bottom">
                                        <ActionableMetricView
                                            onMetricCountClick={() => {
                                                dispatch({ type: 'LOAD_VIEW', data:{filters: getPackageDrilDownRequestFilter(viewModel.metricResult, selectedTabForPackages, PACKAGE_STATUSES_STAGE, viewModel.stationTimeZone, addShipOptionForDwellDetail), 
                stationCode, view : "PACKAGE_DRILLDOWN", prevView : viewModel.prevView, leg : "FORWARD", dispatcher: dispatch, isCPTFilter: false, 
                filterDispatcher: filterDispatcher
            }})
            filterDispatcher({type: DWELL_FILTER_ACTIONS.SELECT_TILE, selectedTile: [DWELL_PACKAGE_STATUS.STAGED]});
                                            }}
                                            dwellStatus={{
                                                title: "dwell.stage",
                                                message: "Staged",
                                                value: packageDwellMetrics.stagedPackages
                                            }}/>
                                    </Row>
                            </Box>
                            <Box type="outline" spacingInset="medium">
                                <b><FormattedMessage id="dwell.stowedHeading" defaultMessage="Depart"/></b>
                                    <Row width="100%" spacing="large" alignmentVertical="bottom">
                                        <ActionableMetricView
                                            onMetricCountClick={() => {
                                                dispatch({ type: 'LOAD_VIEW', data:{filters: getPackageDrilDownRequestFilter(viewModel.metricResult, selectedTabForPackages, PACKAGE_STATUSES_DEPART, viewModel.stationTimeZone, addShipOptionForDwellDetail), 
                stationCode, view : "PACKAGE_DRILLDOWN", prevView : viewModel.prevView, leg : "FORWARD", dispatcher: dispatch, isCPTFilter: false, 
                filterDispatcher: filterDispatcher
            }})
            filterDispatcher({type: DWELL_FILTER_ACTIONS.SELECT_TILE, selectedTile: [DWELL_PACKAGE_STATUS.DEPARTED]});
                                            }}
                                            dwellStatus={{
                                                title: "dwell.depart",
                                                message: "Departed",
                                                value: packageDwellMetrics.departedPackages
                                            }}/>
                                    </Row>
                            </Box>
                        </React.Fragment>
                    }
            </Row>
        </React.Fragment>
    );
}

export default DwellOverallStatus


// WEBPACK FOOTER //
// ./src/components/dwellRush/DwellOverallStatus.js